import React from "react";
import { Routes, Route } from "react-router-dom";
import Celebrities from "./Celebrities";
import Celebrity from "./Celebrity";
import Booking from "./Booking";
import Layout from "../Layout";
import OrderConfirm from "./OrderConfirm";
import DownloadOrder from "./DownloadOrder";
import Error404 from "../Error/Error404";
import OrderSummary from "./OrderSummary";
import { useLocalStorage } from "react-use";

const Shop = ({ celebrities }) => {
  const [orderData, setOrderData, removeOrderData] =
    useLocalStorage("_order_data");

  return (
    <Routes>
      <Route
        path="categories/:category"
        element={
          <Layout celebrities={celebrities.items}>
            <Celebrities celebrities={celebrities.items} />
          </Layout>
        }
      />
      <Route
        path=":id/infos"
        element={
          <Celebrity
            celebrities={celebrities.items}
            removeOrderData={removeOrderData}
          />
        }
      />
      <Route
        path=":id/booking"
        element={
          <Booking
            celebrities={celebrities.items}
            orderData={orderData}
            setOrderData={setOrderData}
          />
        }
      />
      <Route path=":id/order-summary" element={<OrderSummary />} />
      <Route
        path="order/confirm/:ref"
        element={
          <Layout celebrities={celebrities.items}>
            <OrderConfirm removeOrderData={removeOrderData} />
          </Layout>
        }
      />
      <Route
        path="order/download"
        element={
          <Layout celebrities={celebrities.items}>
            <DownloadOrder />
          </Layout>
        }
      />
      <Route
        path={"*"}
        element={
          <Layout>
            <Error404 />
          </Layout>
        }
      />
    </Routes>
  );
};

export default Shop;
